import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class GlobalOrganizationService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    getOrganizations({unitId, inn: inn}) {
        let params = {unitId: unitId, inn: inn}
        return Vue.axios.get(`${API_HOST}/api/GlobalOrganization`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: params,
            cancelToken: this.cancelTokenSource.token,
        })
    }

    checkOrganization(organization) {
        return Vue.axios.get(`${API_HOST}/api/CheckGlobalOrganization`, {
            params: {
                name: organization
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    addOrganization({inn, name, address, accountNumber, mfo, phoneNumber, vatRegCode, branchCode, branchName,
                        isLtd, pinfl, contractSum, userFullName, username, password, contractNumber, contractDateFrom,
                        contractDateTo, contractSignerUnitId, isActive, hasContractWithGlobalUnit}) {
        return Vue.axios.post(`${API_HOST}/api/GlobalOrganization`, {
            Inn: inn,
            Name: name,
            Address: address,
            AccountNumber: accountNumber,
            Mfo: mfo,
            VatRegCode: vatRegCode,
            BranchCode: branchCode,
            BranchName:branchName,
            IsLtd: isLtd,
            Pinfl: pinfl,
            ContractSum: contractSum,
            PhoneNumber: phoneNumber,
            UserFullName: userFullName,
            Username: username,
            Password: password,
            ContractNumber: contractNumber,
            ContractDateFrom: contractDateFrom ? contractDateFrom.format("DD.MM.YYYY") : null,
            ContractDateTo: contractDateTo ? contractDateTo.format("DD.MM.YYYY") : null,
            ContractSignerUnitId: contractSignerUnitId,
            IsActive: isActive,
            HasContractWithGlobalUnit: hasContractWithGlobalUnit
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    editOrganization({inn, name, address, accountNumber, mfo, phoneNumber, vatRegCode, branchCode, branchName,
                         isLtd, pinfl, contractSum, contractNumber, contractDateFrom, contractDateTo, contractSignerUnitId, isActive, hasContractWithGlobalUnit}) {
        return Vue.axios.put(`${API_HOST}/api/GlobalOrganization`, {
            Inn: inn,
            Name: name,
            Address: address,
            AccountNumber: accountNumber,
            Mfo: mfo,
            PhoneNumber: phoneNumber,
            VatRegCode: vatRegCode,
            BranchCode: branchCode,
            BranchName: branchName,
            IsLtd: isLtd,
            Pinfl: pinfl,
            ContractSum: contractSum,
            ContractNumber: contractNumber,
            ContractDateFrom: contractDateFrom ? contractDateFrom.format("DD.MM.YYYY") : null,
            ContractDateTo: contractDateTo ? contractDateTo.format("DD.MM.YYYY") : null,
            ContractSignerUnitId: contractSignerUnitId,
            IsActive: isActive,
            HasContractWithGlobalUnit: hasContractWithGlobalUnit
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: inn
            }
        })
    }

    delete(id) {
        let params = {id: id}
        return Vue.axios.delete(`${API_HOST}/api/GlobalOrganization`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: params
        })
    }
}

export default new GlobalOrganizationService()
